var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CampaignService } from '../../services/campaign/campaign.service';
import { UserService } from '../../services/user.service';
import { MentionService } from '../../services/mention/mention.service';
import { CampaignInfluencerStatus, CampaignsDetailComponent, CampaignTab, TermActionType } from './campaign-detail.component';
import { Location as NgCommonLocation } from '@angular/common';
import { ModalService } from '../../services/modal/modal.service';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { Campaign } from '../../../models/campaign';
import { ValidationHandlerService } from '../../core/validation-handler.service';
import { WebUtils } from '../../utils/web.utils';
import { ActionDetails, ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { CacheService } from '../../services/cache/cache.service';
import { DateUtils } from '../../utils/date.utils';
import { CampaignInfluencerStatus as CampaignStatus } from '../../app.constants';
var CampaignsEditComponent = /** @class */ (function (_super) {
    __extends(CampaignsEditComponent, _super);
    function CampaignsEditComponent(router, activatedRoute, translate, campaignService, groupService, userService, mentionService, modalService, validateErrorHandler, referenceDataService, location, cacheService, eventTracker) {
        var _this = _super.call(this, router, activatedRoute, translate, campaignService, groupService, userService, mentionService, modalService, validateErrorHandler, referenceDataService, eventTracker, cacheService) || this;
        _this.location = location;
        return _this;
    }
    CampaignsEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub = this.activatedRoute.params.subscribe(function (params) {
            _this.campaignId = params['id'];
            _this.tabKey = params['tab-key'] || CampaignTab.TERMS;
        });
        _super.prototype.ngOnInit.call(this);
    };
    CampaignsEditComponent.prototype.companyChangeCallback = function (companyId) {
        this.reloadData(this.campaignId, companyId);
    };
    // TODO a temporal solution to get the file size. We should move it to WS after saving file size in DB
    CampaignsEditComponent.prototype.calculateFileSize = function (url, materialImages) {
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'blob';
        request.onload = function () {
            var fileSize = request.response.size;
            var materialImage = materialImages.find(function (image) { return image.content === url; });
            if (materialImage) {
                materialImage.fileSize = fileSize;
            }
        };
        request.send();
    };
    CampaignsEditComponent.prototype.reloadData = function (campaignId, companyId) {
        var _this = this;
        // Get campaign details
        this.cacheService.get("campaign_" + campaignId, this.campaignService.getCampaign(campaignId, companyId)).subscribe(function (data) {
            _this.isFetchingInfluencer = true;
            // process campaign data
            _this.parseCampaignData(data.campaign, companyId);
            _this.sendMixpanelEvent(_this.campaign);
            _this.isActiveCampaign = (_this.campaignStatus && _this.campaignStatus === CampaignStatus.ACTIVE) ? true : false;
            _this.isArchivedCampaign = (_this.campaignStatus && _this.campaignStatus === CampaignStatus.ARCHIVED) ? true : false;
            // process term
            _this.savedCampaignTerms = data.terms;
            _this.fetchInfluencersOfCampaign(campaignId);
            _this.selectableCampaignTerms = _this.parseSelectableTerm(data.selectableTerms, data.terms, companyId);
            // process material files
            data.files.forEach(function (image) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.materialImages.push({
                        id: image.id,
                        name: image.fileName,
                        contentType: image.contentType,
                        campaignId: image.campaignId,
                        action: 'none',
                        content: image.fileUrl
                    });
                    this.calculateFileSize(image.fileUrl, this.materialImages);
                    return [2 /*return*/];
                });
            }); });
            // update Tab
            _this.updateTabs();
        });
    };
    CampaignsEditComponent.prototype.fetchInfluencersOfCampaign = function (campaignId) {
        var _this = this;
        this.cacheService.get("campaign_details_influencers_" + campaignId, this.campaignService.getInfluencerByCampaign(campaignId)).subscribe(function (res) {
            // process influencers
            _this.influencers = res.map(function (infl) { return _this.campaignService.mapInfluencerCampaign(infl); });
            _this.campaignInfluencers = _this.influencers;
            _this.isFetchingInfluencer = false;
        });
    };
    CampaignsEditComponent.prototype.parseSelectableTerm = function (selectatbleTerms, terms, companyId) {
        var _this = this;
        selectatbleTerms.forEach(function (x) {
            var match = terms.find(function (a) { return a.termId === x.id; });
            x.params = _this.parseTerm(x);
            x.selected = !!match;
            x.companyId = companyId;
            // Update param value
            if (match && match.paramsAsJson && x.params) {
                var _loop_1 = function (p) {
                    if (!match.paramsAsJson.hasOwnProperty(p)) {
                        return "continue";
                    }
                    var param = x.params.find(function (a) { return a.key === p; });
                    if (param) {
                        param.value = match.paramsAsJson[p].value;
                    }
                };
                for (var p in match.paramsAsJson) {
                    _loop_1(p);
                }
            }
        });
        return selectatbleTerms;
    };
    CampaignsEditComponent.prototype.parseCampaignData = function (campaignData, companyId) {
        // navigate to campaign list when opening a campaign which is NOT belonged to current user
        if (campaignData.companyId !== companyId) {
            this.router.navigate(['campaigns']);
            return;
        }
        this.campaign = campaignData;
        // Extract data
        this.campaignBrief = campaignData.brief;
        this.campaignAdditionalInfo = campaignData.additionalInfo;
        this.campaignName = campaignData.name;
        this.campaignStatus = campaignData.status;
        this.campaignCreatedAt = DateUtils.convertDateToString(new Date(campaignData.createdAt), 'dd-MM-yyyy');
        this.campaignArchivedAt = DateUtils.convertDateToString(new Date(campaignData.endDate), 'dd-MM-yyyy');
        // keywords
        this._mentions = campaignData.projectKeywords.map(function (x) { return x.keyword; });
    };
    CampaignsEditComponent.prototype.sendMixpanelEvent = function (campaign) {
        this.eventTracker.trackUserAction(UserActionType.VIEW, Page.CAMPAIGN_SETTING, {
            id: campaign.id,
            name: campaign.name,
            type: TargetType.CAMPAIGN
        }, {
            source: ActionSource.PAGE,
            actionDetails: campaign.status === CampaignStatus.ARCHIVED
                ? ActivePages.ARCHIVED_CAMPAIGN : ActivePages.ACTIVE_CAMPAIGN
        }, undefined, undefined);
    };
    CampaignsEditComponent.prototype.getEditTerms = function () {
        var _this = this;
        var savedTerms = this.savedCampaignTerms;
        var selectedTerms = this.selectedCampaignTerms;
        // edit terms
        var editTerms = selectedTerms
            .filter(function (x) { return savedTerms.some(function (a) { return a.termId === x.id; }); })
            .map(function (x) {
            var id = savedTerms.find(function (a) { return a.termId === x.id; }).id;
            return {
                id: id,
                termId: x.id,
                action: TermActionType.EDIT,
                params: x.hasParams ? _this.extractParams(x.params) : null
            };
        });
        var addTerms = selectedTerms
            .filter(function (x) { return !savedTerms.some(function (a) { return a.termId === x.id; }); })
            .map(function (x) {
            return {
                termId: x.id,
                action: TermActionType.ADD,
                params: x.hasParams ? _this.extractParams(x.params) : null
            };
        });
        var deleteTerms = savedTerms
            .filter(function (x) { return !selectedTerms.some(function (a) { return a.id === x.termId; }); })
            .map(function (x) {
            return {
                id: x.id,
                termId: x.termId,
                action: TermActionType.DELETE,
                params: x.hasParams ? _this.extractParams(x.params) : null
            };
        });
        return editTerms.concat(addTerms, deleteTerms);
    };
    CampaignsEditComponent.prototype.getEditFiles = function () {
        return this.materialImages.map(function (x) {
            return {
                id: x.id,
                name: x.name,
                $$hashKey: '',
                fileId: x.id,
                contentType: x.contentType,
                action: x.action
            };
        });
    };
    CampaignsEditComponent.prototype.replaceTabState = function (tabKey) {
        this.tabKey = tabKey;
        var params = {
            queryParams: {
                activeAccount: WebUtils.extractActiveAccountFromUrl()
            }
        };
        var url = this.router.createUrlTree(['/campaigns', this.campaignId, tabKey || CampaignTab.TERMS], params);
        this.location.replaceState(url.toString());
    };
    /**
     * handle update an existing campaign
     */
    CampaignsEditComponent.prototype.createOrUpdateCampaign = function () {
        var _this = this;
        this.isSavingCampaign = true;
        var campaignSaveData = {
            id: this.campaign.id,
            name: this.campaignName,
            projectType: 'CAMPAIGN_CREATION',
            brief: this.campaignBrief,
            additionalInfo: this.campaignAdditionalInfo,
            keywordIds: this._mentions.map(function (x) { return x.id; }),
            terms: this.getEditTerms(),
            influencerIds: this.campaignInfluencers.filter(function (influencer) {
                return (influencer.campaign_influencer_status !== CampaignInfluencerStatus.NEW || !influencer.is_accepted);
            })
                .map(function (x) { return x.influencer_id; }),
            company_id: this.campaign.company_id,
            needSendEmail: false,
            files: this.getEditFiles()
        };
        this.campaignService.updateCampaign(campaignSaveData)
            .subscribe(function (resp) {
            _this.cacheService.clear("campaign_" + _this.campaign.id);
            _this.cacheService.clear("campaign_details_influencers_" + _this.campaign.id);
            _super.prototype.addNewAcceptedToCampaign.call(_this, _this.campaign.id, _this.campaignInfluencers, function () { _this.isSavingCampaign = false; });
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: _this.campaign.id,
                name: _this.campaignName,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, actionDetails: ActionDetails.UPDATED_DETAILS, source: ActionSource.PAGE }, campaignSaveData), undefined, {
                type: ActivePages.CAMPAIGN_EDIT,
                name: _this.campaignName,
                id: _this.campaign.id
            });
            var newAddedInfluencers = _this.campaignInfluencers.filter(function (c) { return c.campaign_influencer_status === 'new'; });
            if (newAddedInfluencers.length > 0) {
                _super.prototype.sendEventWhenAddingInfluencersToCampaign.call(_this, newAddedInfluencers);
            }
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (err) {
            _this.isSavingCampaign = false;
            if (err.error.data === 'invalid_level') {
                _super.prototype.openAddInfluencerToCampaign.call(_this);
                _this.hasInvalidAccountLevelError = true;
                _this.userService.doInvalidActionByLevel('Add to Campaign', err.error.message);
                _super.prototype.sendInvalidActionToSegement.call(_this, _this.groupService.extractLimitInfoFromErrorMessage(err.error.message, _this.campaignInfluencers.filter(function (c) { return c.campaign_influencer_status === 'new'; }).length, _this.userService.maxCampaignInfluencers, true), {
                    campaign_id: _this.campaign.id,
                    campaign_name: _this.campaignName,
                    influencers: campaignSaveData.influencerIds
                });
            }
            else {
                return _this.handleSaveError(err);
            }
        });
    };
    CampaignsEditComponent.prototype.isCampaignDataChanged = function () {
        var hasChangeName = this.campaign && this.campaign.name !== this.campaignName;
        var hasChangeBrief = this.campaign && this.campaign.brief !== this.campaignBrief;
        var termList = this.getEditTerms();
        var hasChangeTermList = termList.filter(function (t) { return t.action === TermActionType.ADD || t.action === TermActionType.DELETE; }).length > 0;
        return this.isDirtyCampaignData || hasChangeName || hasChangeBrief || hasChangeTermList;
    };
    CampaignsEditComponent.prototype.getCampaign = function () {
        var persistedCampaign = new Campaign();
        persistedCampaign.id = this.campaignId;
        return persistedCampaign;
    };
    CampaignsEditComponent.prototype.getCampaignCachingKeys = function () {
        if (this.campaign) {
            return ["campaign_" + this.campaign.id, "campaign_details_influencers_" + this.campaign.id];
        }
        else {
            return [];
        }
    };
    Object.defineProperty(CampaignsEditComponent.prototype, "campaginPopupSubtitle", {
        get: function () {
            if (this.isActiveCampaign) {
                return this.translate.instant('campaigns.campaign_create_at', { createdAt: this.campaignCreatedAt });
            }
            else {
                return this.translate.instant('campaigns.campaign_archive_at', { archivedAt: this.campaignArchivedAt });
            }
        },
        enumerable: true,
        configurable: true
    });
    return CampaignsEditComponent;
}(CampaignsDetailComponent));
export { CampaignsEditComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-edit.component.ts.pre-build-optimizer.js